import React from 'react';
import { Box, Flex, Grid, Text, TextLabel } from '@tonic-one/react';
import PermissionMenu from '../../PermissionMenu';

import { useTranslation } from 'react-i18next';
import { OrganizationCheckbox } from '@Components/OgranizationCheckbox';
import { useRoleDefinitionStore } from '@Models/rbac/useRoleDefinition';
import { Info } from '@Components/Common/Info';

export const RoleDefinition = () => {
  const { t } = useTranslation();
  const { rolePermission, setRolePermission } = useRoleDefinitionStore();

  return (
    <Box>
      <Flex flexDirection="column">
        <Text>{t('administration.rbac.defineRole.desc')}</Text>
        <Flex flexDirection="row" mb={50}>
          <Box mt="32px">
            <Grid rowGap="8px">
              <Grid columnGap="24px">
                <Grid row="1" width="321px">
                  <Flex alignItems="center">
                    <TextLabel whiteSpace="nowrap" className="required">
                      {t('common.label.organizations')}:
                    </TextLabel>
                    <Info
                      iconStyle={{ ml: '2x', mt: '2px' }}
                      content={t('administration.rbac.allOrganization.desc')}
                    />
                  </Flex>
                </Grid>

                <Grid row="1" width="328px">
                  <OrganizationCheckbox />
                </Grid>
              </Grid>

              <Grid columnGap="24px">
                <Grid row="1" width="128px">
                  <Flex alignItems={'center'}>
                    <TextLabel whiteSpace="nowrap" className="required">
                      {t('common.label.permissions')}:
                    </TextLabel>
                    <Info
                      iconStyle={{ ml: '2x', mt: '2px' }}
                      content={t('administration.rbac.permissionTooltip.desc')}
                    />
                  </Flex>
                </Grid>
              </Grid>

              <Grid columnGap="24px" ml={16}>
                <Grid row="1" width="305px">
                  <Flex alignItems="center">
                    <Text>{t('side.group.dashboard')}</Text>
                  </Flex>
                </Grid>
                <Grid row="1">
                  <PermissionMenu
                    selectedStatus={rolePermission.dashboard}
                    setSelectedStatus={(status) => {
                      setRolePermission({
                        ...rolePermission,
                        dashboard: status,
                      });
                    }}
                  />
                </Grid>
              </Grid>

              <Grid columnGap="24px" ml={16}>
                <Grid row="1" width="305px">
                  <Flex alignItems="center">
                    <Text>
                      {t('side.group.policy')} {'>'}{' '}
                      {t('policy.emailPolicy.atp')}
                    </Text>
                  </Flex>
                </Grid>
                <Grid row="1">
                  <PermissionMenu
                    selectedStatus={rolePermission.atpPolicy}
                    setSelectedStatus={(status) => {
                      setRolePermission({
                        ...rolePermission,
                        atpPolicy: status,
                      });
                    }}
                  />
                </Grid>
              </Grid>

              <Grid columnGap="20px" ml={16}>
                <Grid row="1" width="305px">
                  <Text>
                    {t('side.group.policy')} {'>'} {t('policy.emailPolicy.dlp')}
                  </Text>
                </Grid>
                <Grid row="1">
                  <PermissionMenu
                    selectedStatus={rolePermission.dlpPolicy}
                    setSelectedStatus={(status) => {
                      setRolePermission({
                        ...rolePermission,
                        dlpPolicy: status,
                      });
                    }}
                  />
                </Grid>
              </Grid>

              <Grid columnGap="20px" ml={16}>
                <Grid row="1" width="305px">
                  <Text>{t('common.label.logAndReports')}</Text>
                </Grid>
                <Grid row="1">
                  <PermissionMenu
                    selectedStatus={rolePermission.logReport}
                    setSelectedStatus={(status) => {
                      setRolePermission({
                        ...rolePermission,
                        logReport: status,
                      });
                    }}
                  />
                </Grid>
              </Grid>

              <Grid columnGap="20px" ml={16}>
                <Grid row="1" width="305px">
                  <Text>{t('side.group.operations')}</Text>
                </Grid>
                <Grid row="1">
                  <PermissionMenu
                    selectedStatus={rolePermission.quarantine}
                    setSelectedStatus={(status) => {
                      setRolePermission({
                        ...rolePermission,
                        quarantine: status,
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
